import {z} from 'zod';

export enum AttributeVocabularyValueInsert {
	BEFORE = -1,
	AFTER = 0,
}

export const AttributeVocabularyValueSchema = z.object({
	id: z.number().int().positive(),
	value: z.string(),
	assetCount: z.number().int().nonnegative(),
	ordinal: z.number().int().nonnegative(),
});

export type IAttributeVocabularyValue = z.infer<
	typeof AttributeVocabularyValueSchema
>;

export const AttributeVocabularyValueField =
	AttributeVocabularyValueSchema.keyof().enum;

export const AttributeVocabularyValuesFormSchema = z.object({
	values: z.array(z.string()),
	beforeOrAfterExistingId: z.nativeEnum(AttributeVocabularyValueInsert),
	valueId: z.number().int(),
	id: z.number().int(),
});

export type IAttributeVocabularyValuesFormValues = z.infer<
	typeof AttributeVocabularyValuesFormSchema
>;

export const AttributeVocabularyMergeValuesFormSchema = z.object({
	valueToMergeFrom: z.number().int().positive(),
	valueToMergeTo: z.number().int().positive(),
});

export type IAttributeVocabularyMergeValuesFormValues = z.infer<
	typeof AttributeVocabularyMergeValuesFormSchema
>;
